const { prop } = require('ramda');
module.exports = prop('status');
